<template>
    <div id="logoutOverlay" class="overlay">
      <div id="logoutModal" class="modal" v-click-outside="toggleLogoutModal">
        <div class="modal-header">
          <div id="logoutHeader">LOGOUT</div>
        </div>
        <div id="logoutContent" class="modal-content">
          <div id="logoutConfirmation">
            Are you sure you wish to log out?
          </div>
          <div id="logoutControls">
            <div id="cancelButton" class="game-button" @click="toggleLogoutModal">CANCEL</div>
            <div id="confirmButton" class="game-button" @click="logout">LOG OUT</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LogoutModal',
  components: {

  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
    ]),
  },
  methods: {
    ...mapActions([
      'logout',
      'toggleLogoutModal',
    ]),
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {

    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style >
  #logoutOverlay{

  }

  #logoutModal{

  }

  #logoutContent{

  }

  #logoutConfirmation{
    font-size: 26px;
    font-weight: bold;
    padding: 10px 0px;
    width: 80%;
    margin: 20px auto 10px auto;
  }

  #logoutControls{
    width: 100%;
    margin: 20px auto;
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }

  #cancelButton, #confirmButton{
    font-size: 24px;
    margin: 5px auto;
  }
  #cancelButton, #confirmButton:hover{
    cursor: pointer;
  }
</style>